import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/red160px.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "ml-0"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "max-w-xs max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl border border-gray-400 bg-white rounded-b lg:rounded-r p-2 my-1 mx-1" }
const _hoisted_5 = { class: "bg-white" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "mb-8" }
const _hoisted_8 = { class: "text-gray-700 overflow-hidden text-base" }
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "flex flex-row justify-center items-center m-4" }
const _hoisted_15 = {
  type: "text",
  ref: "debugRef",
  maxlength: "128",
  minlength: "1",
  class: "shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "sm:flex"
}
const _hoisted_19 = {
  class: "h-auto w-32 flex-none rounded-t-none justify-center overflow-hidden",
  title: "token"
}
const _hoisted_20 = { class: "relative w-full" }
const _hoisted_21 = ["href"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "flex justify-end" }
const _hoisted_27 = { class: "ml-0" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  type: "button",
  class: "inline-block px-6 py-2.5 text-gray-500 leading-tight rounded shadow-md",
  disabled: ""
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  class: "animate-spin h-3 w-8 absolute",
  src: _imports_0
}, null, -1)
const _hoisted_32 = { class: "ml-10" }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = {
  key: 0,
  type: "button",
  class: "inline-block px-6 py-2.5 text-gray-500 leading-tight rounded shadow-md",
  disabled: ""
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  class: "animate-spin h-3 w-8 absolute",
  src: _imports_0
}, null, -1)
const _hoisted_36 = { class: "ml-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.hasMetaMask)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("message.youNeedMeta")), 1))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_ctx.user?.userType == 'wallet' && _ctx.account)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, [
                        _createTextVNode(_toDisplayString(_ctx.$t("message.selectContract")) + ": ", 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ownedContract) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validTokenContracts, (contract) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: contract.name,
                              key: contract.name
                            }, _toDisplayString(contract.name) + " : " + _toDisplayString(contract.chainId), 9, _hoisted_9))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.ownedContract]
                        ]),
                        _hoisted_10,
                        _createTextVNode(" Account: " + _toDisplayString(_ctx.account) + " ", 1),
                        _hoisted_11,
                        _createTextVNode(" chainID(" + _toDisplayString(_ctx.nChainId) + ") ", 1),
                        _hoisted_12
                      ])
                    ]),
                    (_ctx.isDebugTest)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("input", _hoisted_15, null, 512)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.tokens && _ctx.tokens.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.selectToken")) + ": ", 1),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ownedTokenId) = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: token.tokenID,
                                key: token.tokenID
                              }, _toDisplayString(token.displayID) + " : " + _toDisplayString(token.tokenName), 9, _hoisted_17))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.ownedTokenId]
                          ]),
                          (_ctx.nftstore)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("a", {
                                      href: `${_ctx.contract.openseaUrl}/${_ctx.contract.contractAddress}/${_ctx.ownedTokenId}`,
                                      target: "_blank"
                                    }, [
                                      _createElementVNode("img", {
                                        src: _ctx.nftstore.token.image,
                                        class: "w-full"
                                      }, null, 8, _hoisted_22)
                                    ], 8, _hoisted_21)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (_ctx.contract)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.youDonthaveToken", {
                    tokenName: _ctx.contract.name,
                  })), 1),
                                _hoisted_25
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    class: "inline-block bg-gray-200 hover:bg-white rounded-full text-sm font-semibold text-gray-700 px-3 py-1",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fetchNFT && _ctx.fetchNFT(...args)))
                  }, _toDisplayString(_ctx.$t("function.fetchNFT")), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, [
          (_ctx.user && _ctx.user.userType == 'wallet')
            ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                _createElementVNode("button", {
                  class: "bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow",
                  id: "SignOut",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
                }, _toDisplayString(_ctx.$t("function.signout")), 1)
              ]))
            : (_ctx.account)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                  (_ctx.isBusy)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("message.processing")), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args))),
                        id: "SignInWallet",
                        class: "bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
                      }, _toDisplayString(_ctx.$t("function.signinWallet")), 1))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_33, [
                  (_ctx.isBusy)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("message.processing")), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.connect && _ctx.connect(...args))),
                        id: "ConnectMetamask",
                        class: "bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
                      }, _toDisplayString(_ctx.$t("function.requestAccount")), 1))
                ]))
        ])
      ]))
}